export const profilePermissionsMap = {
  1: ['consulta', 'registro', 'logistica', 'admin'],
  4: ['consulta', 'registro', 'logistica', 'admin'],
  5: ['consulta', 'logistica'],
  6: ['consulta'],
  7: ['consulta'],
  8: ['consulta'],
  9: ['consulta', 'logistica'],
}

export const profileRolesMap = {
  1: 'Administrador',
  4: 'Gestor',
  5: 'Instalador',
  6: 'Parceiro',
  7: 'Facilitador',
  8: 'Comunitário',
  9: 'Logística',
}
